import { call, put as putEffect } from 'redux-saga/effects';
import _ from 'lodash';

import { get, remove } from '../../utils/request';
import { showError } from '../actions/dialogs';

// TODO remove
function save() {

}
// TODO remove
function update() {

}

function fetchSaga(routine, pathExtractor, enrich = (obj) => obj) {
  function* result(action) {
    try {
      const account = {}; // TODO FIX //AccountsService.currentAccount() || {}; //TODO FIX
      // trigger request action
      yield putEffect(routine.request(action.payload));
      // perform request to '/some_url' to fetch some data

      const response = yield call((obj) => get({
        url: pathExtractor(action.payload, account.id),
      }));

      // const response = yield call((obj) => fetchCol(pathExtractor(action.payload), enrich));
      // if request successfully finished
      yield putEffect(routine.success({ success: true, request: action.payload, response }));
    } catch (error) {
      console.error(error);
      yield putEffect(showError('Error', error.message ));
      // if request failed
      yield putEffect(routine.failure(error));
    } finally {
      // trigger fulfill action
      yield putEffect(routine.fulfill());
    }
  }

  return result;
}

function fetchCsvSaga(routine, pathExtractor) {
  function* result(action) {
    try {
      const account = {}; // TODO FIX = AccountsService.currentAccount() || {};
      // trigger request action
      yield putEffect(routine.request(action.payload));
      // perform request to '/some_url' to fetch some data

      const response = yield call((obj) => get({
        url: pathExtractor(action.payload, account.id),
        headers: {
          Accept: 'text/csv',
        }
      }));

      // const response = yield call((obj) => fetchCol(pathExtractor(action.payload), enrich));
      // if request successfully finished
      yield putEffect(routine.success({ success: true, request: action.payload, response }));
    } catch (error) {
      console.error(error);
      yield putEffect(showError('Error', error.message ));
      // if request failed
      yield putEffect(routine.failure(error));
    } finally {
      // trigger fulfill action
      yield putEffect(routine.fulfill());
    }
  }

  return result;
}

function saveSaga(routine, pathExtractor, methodExtractor, payloadExtractor, options = {}) {
  function* result(action) {
    try {
      const account = {}; // TODO FIX  AccountsService.currentAccount() || {};
      // const payload = payloadExtractor(action.payload);
      // console.log('payload', payload);
      // trigger request action
      yield putEffect(routine.request(action.payload));
      // perform request to '/some_url' to fetch some data
      const func = methodExtractor(action.payload);
      const data = yield payloadExtractor(action.payload);
      if (!options || !options.condition || options.condition(action.payload)) {
        const response = yield call((obj) => func(_.assign({
          url: pathExtractor(action.payload, account.id),
          data,
        }, options.request)));

        // if request successfully finished
        yield putEffect(routine.success({ success: true, request: action.payload, response }));

        if (options) {
          if (options.onSuccess) {
            yield putEffect(options.onSuccess);
          }
        }

      } else {
        console.log('conditions prevent action');
      }

      // return response;
    } catch (error) {
      console.error('ERRR', error);
      yield putEffect(showError('Error', error.message));
      // if request failed
      yield putEffect(routine.failure(error));
    } finally {
      // trigger fulfill action
      yield putEffect(routine.fulfill());
    }
  }

  return result;
}

function removeSaga(routine, pathExtractor) {
  function* result(action) {
    const payload = action.payload;
    try {
      const account = {}; // TODO fix account = AccountsService.currentAccount() || {};
      // trigger request action
      yield putEffect(routine.request(payload));
      // perform request to '/some_url' to fetch some data
      yield call((obj) => remove({
        url: pathExtractor(payload, account.id),
      }));
      // if request successfully finished
      yield putEffect(routine.success({ success: true, request: action.payload }));
    } catch (err) {
      console.error(err);
      yield putEffect(showError('Error', err.message));
      // if request failed
      yield putEffect(routine.failure(err));
    } finally {
      // trigger fulfill action
      yield putEffect(routine.fulfill());
    }
  }

  return result;
}

function genericSaga(routine, op, payloadExtractor = (payload) => payload) {
  function* result(action) {
    try {
      const account = {}; // TODO FIX = AccountsService.currentAccount() || {};
      yield putEffect(routine.request(action.payload));
      // perform request to '/some_url' to fetch some data
      const response = yield call(op, payloadExtractor(action.payload), account.id);
      // if request successfully finished
      yield putEffect(routine.success({ success: true, request: action.payload, response }));
    } catch (error) {
      console.error(error);
      yield putEffect(showError('Error', error.message));
      // if request failed
      yield putEffect(routine.failure(error));
    } finally {
      // trigger fulfill action
      yield putEffect(routine.fulfill());
    }
  }

  return result;
}

const buildFilterQuery = (filters = {}) => {
  return _.keys(filters).reduce((res, key) => {
    const value = filters[key];

    if (key === 'pageSize') {
      return res;
    }

    if (_.isArray(value)) {
      return res + _.join(value.map((v) => `${key}=${v}&`), '');
    } else if (value || value === false) {
      return `${res}${key}=${value}&`;
    }

    return res;
  }, '');
};

export {
  save,
  update,

  fetchSaga,
  fetchCsvSaga,
  saveSaga,
  removeSaga,
  genericSaga,

  buildFilterQuery,
};



// WEBPACK FOOTER //
// ./src/redux/sagas/helper.js